export default __webpack_public_path__ + "static/SSSpyView_screenshot-4@2x-9e4e23f48b8e830f1f0dbebadf27d123.webp";